import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';

import { getSafeUserId } from '../utils';
import Popup from '../../../common/Popup';
import Loader from '../../../common/Loader';
import { ACTIVITY_LOG_USER_ACTION_TYPE } from '../../constants';
import LabTestResultCard from '../DataList/Card/LabTestResultCard';
import LabTestResultDetailsCard from '../DataList/Card/LabTestResultCard/LabTestResultDetailsCard';
import LabTestResultDetailsCardDocuments from '../DataList/Card/LabTestResultCard/LabTestResultDetailsCard/LabTestResultDetailsCardDocuments';
import { enhance } from './enhance';
import styles from './index.styl';

const { VIEW } = ACTIVITY_LOG_USER_ACTION_TYPE;

function ResultsDetailsModal({
  clear,
  close,
  entity,
  pending,
  mainUserId,
  ccdLabTestId,
  targetUserId,
  getDetailsReq,
  detailsEntity,
  resultDocument,
  loggingViewAction,
  intl: { formatMessage },
  openedResultsDetailsModal,
}) {
  const { safeUserId } = getSafeUserId(targetUserId, mainUserId);

  useEffect(() => {
    if (openedResultsDetailsModal && ccdLabTestId) {
      getDetailsReq({ ccdLabTestId, userId: safeUserId });
    }
  }, [openedResultsDetailsModal, ccdLabTestId, safeUserId]);

  const handleCloseModal = () => {
    clear();
    close();
  };

  const loggingView = documentUid => {
    loggingViewAction({
      userId: safeUserId,
      actionType: VIEW,
      documentUid,
    });
  };

  return (
    <Popup
      title={formatMessage({ id: 'patient.portal.labTestResult.modalTitle' })}
      onClose={handleCloseModal}
      opened={openedResultsDetailsModal}
      mobileFullScreen={false}
      overflowVisible
      width="auto"
      strictClose
    >
      <div className={styles.boxShadow}>
        <div className={styles.root}>
          <LabTestResultCard entity={entity} detailsMode />
          {pending && <Loader />}
          {!pending && detailsEntity.length !== 0 && (
            <LabTestResultDetailsCard
              formatMessage={formatMessage}
              headerMode
            />
          )}
          <div className={styles.content}>
            {!pending &&
              detailsEntity.length !== 0 &&
              detailsEntity.map(item => (
                <LabTestResultDetailsCard
                  key={item.id}
                  entity={item}
                  formatMessage={formatMessage}
                />
              ))}
            {resultDocument && !pending && (
              <LabTestResultDetailsCardDocuments
                loggingView={loggingView}
                formatMessage={formatMessage}
                resultDocument={resultDocument}
              />
            )}
          </div>
        </div>
      </div>
    </Popup>
  );
}

ResultsDetailsModal.propTypes = {
  clear: PropTypes.func,
  close: PropTypes.func,
  intl: PropTypes.object,
  pending: PropTypes.bool,
  entity: PropTypes.object,
  mainUserId: PropTypes.number,
  getDetailsReq: PropTypes.func,
  detailsEntity: PropTypes.array,
  targetUserId: PropTypes.number,
  loggingViewAction: PropTypes.func,
  openedResultsDetailsModal: PropTypes.bool,
  ccdLabTestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resultDocument: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default enhance(ResultsDetailsModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/ResultsDetailsModal/index.jsx